import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-border/50 py-12 bg-secondary/20">
      <div className="container px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div>
            <Link to="/" className="font-display text-xl font-bold tracking-tight">
              <span className="text-gradient-primary">VIZ</span>
            </Link>
            <p className="text-sm text-muted-foreground mt-1">
              AI-powered mental training for athletes.
            </p>
          </div>

          <div className="flex gap-6 text-sm text-muted-foreground">
            <a href="#features" className="hover:text-foreground transition-colors">Features</a>
            <a href="#pricing" className="hover:text-foreground transition-colors">Pricing</a>
            <Link to="/login" className="hover:text-foreground transition-colors">Log In</Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
          </div>

          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} VIZ. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
